import { FC } from 'react';
import SupersetDashboard from '../superset/supersetDashboard/SupersetDashboard';
import { useEffect, useState } from 'react';
import { useStyles } from './styles';
import SgtaService from '../../services/sgtaService/SgtaService';
import { useStream } from '../../hooks/useStream';
import StateService from '../../services/stateService/StateService';
import { json } from 'stream/consumers';
import { log } from 'util';
import { env } from '../../env';

const Dashboard: FC = () => {
    const classes = useStyles();
    const [supersetConfig, setSupersetConfig] = useState<{
        superset_url: string | undefined;
        dashboard_id: string | undefined;
        guest_token: any;
    }>({
        superset_url: undefined,
        dashboard_id: undefined,
        guest_token: undefined,
    });
    const abortController = new AbortController();
    const [loading, setLoading] = useState(true);
    const [selectedStage] = useStream(StateService.selectedStage$);
    const [stageViewMode] = useStream(StateService.stageViewMode$);
    const [selectedWidgetData, _setselectedWidgetData] = useStream(StateService.selectedWidgetData$);
    const [widgetData, _setWidgetData] = useStream(StateService.widgetData$);
    const [currentCustomerUuid, setCurrentCustomerUuid] = useStream(StateService.currentCustomerUuid$);

    useEffect(() => {
        const initializeDashboard = async () => {
            const supersetBaseUrl = selectedWidgetData?.dashboardUrl || env.REACT_APP_SUPERSET_BASE_URL;
            const supersetUuid = widgetData ? widgetData[0]?.supersetUuid : '';

            if (!supersetUuid || !supersetBaseUrl) {
                return;
            }

            try {
                const guestToken = await SgtaService.getGuesttoken(supersetUuid, currentCustomerUuid, {
                    signal: abortController.signal,
                });

                setSupersetConfig({
                    superset_url: supersetBaseUrl,
                    dashboard_id: supersetUuid,
                    guest_token: guestToken,
                });
                setLoading(false);
            } catch (err) {
                console.error('Error while getting guest token:', err);
            }
        };

        initializeDashboard();
    }, [selectedStage, widgetData]);

    return (
        <div className={classes.dashboardWrapper}>
            {!loading && supersetConfig.superset_url && supersetConfig.dashboard_id && supersetConfig.guest_token && (
                <SupersetDashboard
                    superset_url={supersetConfig?.superset_url}
                    dashboard_id={supersetConfig?.dashboard_id}
                    guest_token={supersetConfig?.guest_token?.guest_token}
                />
            )}
        </div>
    );
};

export default Dashboard;
